var map = {
	"./caidan.svg": "a9a3",
	"./check.svg": "f75a",
	"./menu_application.svg": "1f5b",
	"./menu_document.svg": "cc09",
	"./menu_dormitory.svg": "5f02",
	"./menu_financial.svg": "1b76",
	"./menu_guest.svg": "38a3",
	"./menu_hostel_checkout_reservation.svg": "5289",
	"./menu_index.svg": "1c4c",
	"./menu_overnight.svg": "15ce",
	"./menu_report_center.svg": "e8a3",
	"./menu_return_in_night.svg": "ac30",
	"./menu_system_management.svg": "e402",
	"./triangledown.svg": "4271",
	"./triangleup.svg": "c204"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";